import TieredPricingForm from "./TieredPricingForm"

interface ITieredPricing{
  disableField:boolean;
}

const TieredPricing = (props:ITieredPricing) => {
  const {disableField} = props
  
  const handleSave = (values:any) =>{
    //
  }

  const pricingData = [
    {
      orderSequence:0,
      name:"Visa/MC/Discover",
      rate:"Qualified Rate",
      value:2.5,
      lock:false,
    },
    {
      orderSequence:1,
      name:"Visa/MC/Discover",
      rate:"Mid-Qualified Rate",
      value:4.5,
      lock:false
    },
    {
      orderSequence:2,
      name:"Visa/MC/Discover",
      rate:"Non-Qualified Rate",
      value:6.5,
      lock:false
    },
    {
      orderSequence:3,
      name:"Transaction Fees (all transactions)",
      value:3.4,
      lock:true
    },
    {
      orderSequence:4,
      name:"Capture/Settlement Per Item Fee",
      value:6,
      lock:false,
    },
    {
      orderSequence:5,
      name:"AmEx",
      rate:"Qualified Rate",
      value:2.5,
      lock:false,
    },
    {
      orderSequence:6,
      name:"AmEx",
      rate:"Mid-Qualified Rate",
      value:4.5,
      lock:false,
    },
    {
      orderSequence:7,
      name:"AmEx",
      rate:"Non-Qualified Rate",
      value:4.5,
      lock:false,
    },
    {
      orderSequence:8,
      name:"Authorization Fee",
      value:1,
      lock:false,
    },
  ]

  const initialData = pricingData.reduce((acc:any, item) => {
      acc[`${item.name}${item.rate}`] = item.value;
    return acc;
  }, {});
  
  return(
    <div className="tieredPricing">
      <TieredPricingForm handleSave = {handleSave} initialData={initialData} pricingData={pricingData} disableField={disableField}/>
    </div>
  )
}

export default TieredPricing